<template>
  <div class="content">
    <section class="text-section">
      <h1>{{ greetingMessage }}</h1>
      <p>
        {{ mainMessage }}
      </p>
    </section>

    <section class="icon-grid">

      <div class="icon-wrapper" v-if="check('USERS')">
        <router-link class="pageLink" to="/biomanager/users">
          <div class="icon-box">
            <img alt="icon" class="turnIconWhite" src="../../../static/img/components-icons/users-three.svg">
          </div>
        </router-link>
        <span class="icon-description">Usuários</span>
      </div>

      <div class="icon-wrapper" v-if="check('AGENTSUPT')">
        <router-link class="pageLink" to="/biomanager/agentsupdate">
          <div class="icon-box">
            <img alt="icon" src="../../../static/img/components-icons/icone-pf.svg">
          </div>
        </router-link>
        <span class="icon-description">Atualização de Agentes</span>
      </div>

      <!-- <div class="icon-wrapper" v-if="check('BIO')">
        <router-link class="pageLink" to="/biomanager/manage">
          <div class="icon-box">
            <img alt="icon" class="turnIconWhite" src="../../../static/img/magnifying-glass.svg">
          </div>
        </router-link>
        <span class="icon-description">Consulta Biométrica</span>
      </div> -->

      <div class="icon-wrapper" v-if="check('BIO')">
        <router-link class="pageLink" to="/biomanager/managepsbio">
          <div class="icon-box">
            <img alt="icon" class="turnIconWhite" src="../../../static/img/reader-outline.svg">
          </div>
        </router-link>
        <span class="icon-description">Consulta Biométrica Griaule</span>
      </div>

      <!-- <div class="icon-wrapper" v-if="check('BIO')">
        <router-link class="pageLink" to="/biomanager/consultapsbio">
          <div class="icon-box">
            <img alt="icon" class="turnIconWhite" src="../../../static/img/magnifying-glass-plus.svg">
          </div>
        </router-link>
        <span class="icon-description">Consulta Biométrica PSBIO</span>
      </div> -->

      <div class="icon-wrapper" v-if="check('BIO')">
        <router-link class="pageLink" to="/biomanager/consultaspid">
          <div class="icon-box">
            <img alt="icon" class="turnIconWhite" src="../../../static/img/query_spid.svg">
          </div>
        </router-link>
        <span class="icon-description">Consulta Biométrica SPID</span>
      </div>

      <div class="icon-wrapper" v-if="check('BIO')">
        <router-link class="pageLink" to="/biomanager/findpsbioorigin">
          <div class="icon-box">
            <img alt="icon" class="turnIconWhite" src="../../../static/img/atom.svg">
          </div>
        </router-link>
        <span class="icon-description">Consulta Origem IDN</span>
      </div>

      <div class="icon-wrapper" v-if="check('EXCBIO')">
        <router-link class="pageLink" to="/biomanager/delete">
          <div class="icon-box">
            <img alt="icon" src="../../../static/img/components-icons/Icon-material-update.svg">
          </div>
        </router-link>
        <span class="icon-description">Exclusão Biométrica</span>
      </div>

      <!-- <div class="icon-wrapper" v-if="check('EXCBIO')">
        <router-link class="pageLink" to="/biomanager/export">
          <div class="icon-box">
            <img alt="icon" src="../../../static/img/components-icons/Icon-feather-database.svg">
          </div>
        </router-link>
        <span class="icon-description">Exportação Biométrica</span>
      </div> -->

      <div class="icon-wrapper" v-if="check('AUDIT')">
        <router-link class="pageLink" to="/biomanager/subjectaudit">
          <div class="icon-box">
            <img alt="icon" src="../../../static/img/components-icons/icone-bancos.svg">
          </div>
        </router-link>
        <span class="icon-description">Auditoria de Sujeitos</span>
      </div>

      <div class="icon-wrapper" v-if="check('FRAUD')">
        <router-link class="pageLink" to="/biomanager/fraud">
          <div class="icon-box">
            <img alt="icon" src="../../../static/img/components-icons/Group-282.svg">
          </div>
        </router-link>
        <span class="icon-description">Análise de Fraude</span>
      </div>

      <!-- <div class="icon-wrapper" v-if="check('STATUS')">
        <router-link class="pageLink" to="/biomanager/psbioinfo">
          <div class="icon-box">
            <img alt="icon" src="../../../static/img/components-icons/Icon-feather-check.svg">
          </div>
        </router-link>
        <span class="icon-description">Status PsBio</span>
      </div>

      <div class="icon-wrapper" v-if="check('ERROS')">
        <router-link class="pageLink" to="/biomanager/psbioerrors">
          <div class="icon-box">
            <img alt="icon" class="turnIconWhite" src="../../../static/img/components-icons/bug-beetle.svg">
          </div>
        </router-link>
        <span class="icon-description">Erros PsBio</span>
      </div>

      <div class="icon-wrapper" v-if="check('PSBIO')">
        <router-link class="pageLink" to="/biomanager/psbiotransactions">
          <div class="icon-box">
            <img alt="icon" class="turnIconWhite" src="../../../static/img/components-icons/share-network.svg">
          </div>
        </router-link>
        <span class="icon-description">Transações e Comunicação</span>
      </div> -->

    </section>
  </div>
</template>

<script>
import interceptor from '../../interceptor'
import roles from '../../roles'

export default {
  data() {
    return {
      greetingMessage: '',
      mainMessage: '',
      userCount: 0,
      psbioErrors: 0,
      psbioSuccess: 0,
      subjectCount: 0,
      biometricNumbers: [],
      year: new Date().getFullYear(),
      userName: {}
    }
  },
  created() {
    this.userName = window.localStorage.getItem('user')
    this.userName = this.userName.replaceAll('"', '')
    this.greetingMessage = `Bem vindo, ${this.userName}!`
    this.mainMessage = 'Selecione abaixo o serviço desejado:'
  },
  methods: {
    check: function (key) {
      return roles.checkrole(window.localStorage.getItem('role'), key, 'VIEW')
    }
  },
  mounted() {
    interceptor.request('get', 'api/v1/users/count', {})
      .then(response => {
        this.userCount = response.data
      })
      .catch(error => {
        console.log(error)
      })
    interceptor.request('get', 'api/v1/psbio/errors/count', {})
      .then(response => {
        this.psbioErrors = response.data
      })
      .catch(error => {
        console.log(error)
      })
    interceptor.request('get', 'api/v1/psbio/success/count', {})
      .then(response => {
        this.psbioSuccess = response.data
      })
      .catch(error => {
        console.log(error)
      })
    if (window.localStorage.getItem('count') === null || window.localStorage.getItem('count') === '0') {
      setTimeout(function () {
        location.reload()
      }, 50)
      window.localStorage.setItem('count', 1)
    }
  }
}
</script>

<style>
.text-section {
  margin: 4rem 0 2rem 0;
  padding: 0 165px;
}

.text-section > h1 {
  font: var(--font-style-normal) normal var(--font-weight-bold) 25px/var(--line-spacing-35) var(--font-family-poppins);
  letter-spacing: var(--character-spacing-0);
  color: #211858;
  text-align: left;
}

.text-section > p {
  font: var(--font-style-normal) normal var(--font-weight-medium) 18px/30px var(--font-family-poppins);
  font-size: var(--font-size-14);
  letter-spacing: var(--character-spacing-0);
  text-align: left;
  color: #494F54;
  white-space: pre-line;
}

.icon-grid {
  margin: 6rem 0 3rem 0;
  padding: 0 165px;
  display: grid;
  row-gap: 6rem;
  grid-template-columns: repeat(5, 1fr);
}

.icon-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
}

.pageLink {
  justify-self: center;
  cursor: pointer;
}

.icon-box {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  height: 79px;
  width: 79px;
  background: #211858 0 0 no-repeat padding-box;
  border-radius: 50%;

  transition: all 0.3s ease-in-out;
  border: 1px solid #CCCCCC;
  float: left;
}

.icon-box:hover {
  box-shadow: 0 0 11px #7030C5;
}

.icon-box > img {
  position: absolute;
  height: 39px;
  width: 39px;
}

.turnIconWhite {
  filter: invert(100%) sepia(5%) saturate(21%) hue-rotate(64deg) brightness(104%) contrast(104%);
}

.icon-description {
  width: 128px;
  height: 53px;
  font: var(--font-style-normal) normal 600 var(--font-size-16)/var(--line-spacing-21) var(--font-family-poppins);
  letter-spacing: var(--character-spacing-0);
  text-align: center;
  color: #494F54;
}

/* ----------------------- MEDIA QUERYS ----------------------- */
@media (max-width: 63em) {
  .icon-grid {
    grid-template-columns: repeat(3, 1fr);
    padding: 0 100px;
  }

  .text-section {
    padding: 0 100px;
  }
}

@media (max-width: 49em) {
  .icon-grid {
    grid-template-columns: repeat(2, 1fr);
    padding: 0 50px;
  }

  .text-section {
    padding: 0 50px;
  }
}

</style>



// WEBPACK FOOTER //
// Dashboard.vue?29b3795e